import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Field } from "react-final-form";
import Section from "../../../common/section";
import { DatePicker, TextInput } from "../../../common/fields";
import TooltipButton from "../../../common/tooltipButton";
import LicenseHistory from "./LicenseHistory";

// The license fields of the add wizard's second step, shown read-only: the sub
// domain, the current license's dates (the latest one's, titled "Latest
// license", when none is current) and the entitlements; with every licence
// and the two changes the super admin can make (add a licence, change the
// entitlements), each in its own dialog.
const EnterpriseLicenseDetails = ({
  canUpdate,
  isCurrentLicense,
  licenses,
  onAddLicense,
  onEditEntitlements,
}) => {
  const intl = useIntl();

  const actionButton = (testId, icon, labelId, onClick) => (
    <TooltipButton
      data-testid={testId}
      icon={icon}
      outlined
      size="small"
      type="button"
      label={intl.formatMessage({ id: labelId })}
      onClick={onClick}
      disabled={!canUpdate}
      tooltipOptions={{ position: "bottom" }}
      tooltip={canUpdate ? "" : intl.formatMessage({ id: "no_permission" })}
    />
  );

  return (
    <div className="grid gap-3">
      <Section
        title={isCurrentLicense ? "current_license" : "latest_license"}
        className="col-12"
        headerAction={actionButton(
          "add-license-button",
          "pi pi-plus",
          "add_license",
          onAddLicense
        )}
      >
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="subDomain"
              component={TextInput}
              type="text"
              label={intl.formatMessage({ id: "subDomain" })}
              placeholder={intl.formatMessage({ id: "subDomain" })}
              disabled
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="license.startDate"
              component={DatePicker}
              label={intl.formatMessage({ id: "startDate" })}
              placeholder={intl.formatMessage({ id: "startDate" })}
              minDate={null}
              disabled
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="license.endDate"
              component={DatePicker}
              label={intl.formatMessage({ id: "endDate" })}
              placeholder={intl.formatMessage({ id: "endDate" })}
              minDate={null}
              disabled
            />
          </div>
        </div>
      </Section>
      <Section title="license_history" className="col-12">
        <LicenseHistory licenses={licenses} />
      </Section>
      <Section
        title="entitlements"
        className="col-12"
        headerAction={actionButton(
          "edit-entitlements-button",
          "pi pi-pencil",
          "edit_entitlements",
          onEditEntitlements
        )}
      >
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="entitlements[0].value"
              component={TextInput}
              type="number"
              label={intl.formatMessage({ id: "no_of_users" })}
              placeholder={intl.formatMessage({ id: "no_of_users" })}
              disabled
            />
          </div>
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              name="entitlements[1].value"
              component={TextInput}
              type="number"
              label={intl.formatMessage({ id: "storage" })}
              placeholder={intl.formatMessage({ id: "storage" })}
              disabled
            />
          </div>
        </div>
      </Section>
    </div>
  );
};

EnterpriseLicenseDetails.propTypes = {
  canUpdate: PropTypes.bool,
  isCurrentLicense: PropTypes.bool,
  licenses: PropTypes.array,
  onAddLicense: PropTypes.func.isRequired,
  onEditEntitlements: PropTypes.func.isRequired,
};

export default EnterpriseLicenseDetails;
